import script from "./UserPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPage.vue?vue&type=script&lang=ts&setup=true"

import "./UserPage.vue?vue&type=style&index=0&id=182af5c5&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182af5c5"]])

export default __exports__